import { render, staticRenderFns } from "./TabReviews.vue?vue&type=template&id=ff063df0&scoped=true&"
import script from "./TabReviews.vue?vue&type=script&lang=js&"
export * from "./TabReviews.vue?vue&type=script&lang=js&"
import style0 from "./TabReviews.vue?vue&type=style&index=0&id=ff063df0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff063df0",
  null
  
)

export default component.exports